import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

import ListGroup from '../Lists/ListGroup/ListGroup';
import ListItem from '../Lists/ListItem/ListItem';

import { IoIosArrowDown } from 'react-icons/io';
import Link from '@components/Link';
import './NavDropdown.scss';

export default function NavDropdown({
    label,
    baseLink,
    list,
    theme,
    className,
    onClick,
    events = {},
}) {
    const { t } = useTranslation();
    let mod_class = [
        'NavDropdown',
        theme !== undefined ? 'theme-' + theme : '',
        className !== undefined ? className : '',
    ];
    mod_class = mod_class.join(' ').replace(/\s{2,}/g, ' ');

    return (
        <div className={mod_class}>
            <div
                className="NavDropdown--label"
                onClick={() => onClick && onClick()}
                {...events}
            >
                {baseLink ? (
                    <Link
                        to={baseLink}
                        className="HeaderNav--item--link"
                        activeClassName="is-active"
                    >
                        {t(label)}
                        <i>
                            <IoIosArrowDown />
                        </i>
                    </Link>
                ) : (
                    <>
                        {t(label)}
                        <i>
                            <IoIosArrowDown />
                        </i>
                    </>
                )}
            </div>
            <div className="NavDropdown--list">
                <ListGroup>
                    {list
                        ? list.map((element, index) => {
                              return (
                                  <ListItem
                                      className="NavDropdown--list--item"
                                      to={element.to}
                                      key={index}
                                  >
                                      {t(element.label)}
                                  </ListItem>
                              );
                          })
                        : ''}
                </ListGroup>
            </div>
        </div>
    );
}
